module.exports = __webpack_public_path__ + "img/4_130.63dcdb49.png";